import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { SocketProvider } from './context/SocketContext';
import UploadPage from './pages/UploadPage';
import ProcessingPage from './pages/ProcessingPage';
import ResultsPage from './pages/ResultsPage';

// function Footer() {
//   return (
//     <footer className="bg-ink-950 border-t border-white/10">
//       <div className="max-w-6xl mx-auto px-4 py-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
//         <div className="lg:col-span-2">
//           <div className="flex items-center gap-2.5">
//             <span className="inline-flex w-8 h-8 rounded-lg bg-brand-600 text-white items-center justify-center">
//               <svg viewBox="0 0 24 24" fill="none" className="w-4.5 h-4.5">
//                 <path
//                   d="M4 6.5A2.5 2.5 0 0 1 6.5 4h7A2.5 2.5 0 0 1 16 6.5v11a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 17.5v-11Z"
//                   stroke="currentColor"
//                   strokeWidth="1.7"
//                 />
//                 <path d="m16 9.5 4.2-2.4a.6.6 0 0 1 .9.52v8.76a.6.6 0 0 1-.9.52L16 14.5" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
//               </svg>
//             </span>
//             <span className="text-[15px] font-semibold tracking-tight text-white">Video Intelligence Studio</span>
//           </div>
//           <p className="text-sm text-slate-400 mt-4 max-w-sm leading-relaxed">
//             Automated video understanding — frame-by-frame scene detection, full audio
//             transcription, and structured, timestamped reporting for any video file.
//           </p>
//         </div>

//         <div>
//           <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">Pipeline</h4>
//           <ul className="space-y-2.5 text-sm text-slate-400">
//             <li>Frame Extraction</li>
//             <li>Audio Transcription</li>
//             <li>Visual Frame Analysis</li>
//             <li>Report Generation</li>
//           </ul>
//         </div>

//         <div>
//           <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">Output</h4>
//           <ul className="space-y-2.5 text-sm text-slate-400">
//             <li>Executive Summary</li>
//             <li>Timestamped Timeline</li>
//             <li>Full Transcript</li>
//             <li>JSON / Report Export</li>
//           </ul>
//         </div>
//       </div>

//       <div className="border-t border-white/10">
//         <div className="max-w-6xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
//           <span>&copy; {new Date().getFullYear()} Video Intelligence Studio. All rights reserved.</span>
//           <span>Supported formats: MP4 &middot; MOV &middot; AVI &middot; MKV &middot; WEBM</span>
//         </div>
//       </div>
//     </footer>
//   );
// }

function Header() {
  return (
    <header className="bg-ink-950 sticky top-0 z-20 border-b border-white/10">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="inline-flex w-8 h-8 rounded-lg bg-brand-600 text-white items-center justify-center">
            <svg viewBox="0 0 24 24" fill="none" className="w-4.5 h-4.5">
              <path
                d="M4 6.5A2.5 2.5 0 0 1 6.5 4h7A2.5 2.5 0 0 1 16 6.5v11a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 17.5v-11Z"
                stroke="currentColor"
                strokeWidth="1.7"
              />
              <path d="m16 9.5 4.2-2.4a.6.6 0 0 1 .9.52v8.76a.6.6 0 0 1-.9.52L16 14.5" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
            </svg>
          </span>
          <span className="text-[15px] font-semibold tracking-tight text-white">Video Intelligence Studio</span>
        </Link>
        <nav className="hidden sm:flex items-center gap-6 text-sm text-slate-400">
          <span className="text-slate-500">Frame Analysis</span>
          <span className="text-slate-700">/</span>
          <span className="text-slate-500">Transcription</span>
          <span className="text-slate-700">/</span>
          <span className="text-slate-500">Reporting</span>
        </nav>
      </div>
    </header>
  );
}

export default function App() {
  return (
    <SocketProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col bg-slate-50">
          <Header />
          <main className="flex-1 w-full">
            <Routes>
              <Route path="/" element={<UploadPage />} />
              <Route
                path="/processing/:jobId"
                element={
                  <div className="max-w-6xl mx-auto px-4 py-10">
                    <ProcessingPage />
                  </div>
                }
              />
              <Route
                path="/results/:jobId"
                element={
                  <div className="max-w-6xl mx-auto px-4 py-10">
                    <ResultsPage />
                  </div>
                }
              />
            </Routes>
          </main>
          {/* <Footer /> */}
        </div>
      </BrowserRouter>
    </SocketProvider>
  );
}
